import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

const Agencies = lazy(() => import(`Pages/Screens/Office/PaymentPlan/Agencias`));
const Modalities = lazy(() => import(`Pages/Screens/Office/PaymentPlan/Modalidades`));
const PaymentPlan = lazy(() => import(`Pages/Screens/Office/PaymentPlan/Page`));

const PaymentPlanRoutes: RouteObject[] = [
    {
      path: 'orgaos',
      element: <LoadComponent component={Agencies} />,
    },
    {
      path: 'modalidades',
      element: <LoadComponent component={Modalities} />,
    },
    {
      path: 'parcelamentos',
      element: <LoadComponent component={PaymentPlan} />,
    },
]

export default PaymentPlanRoutes;
